<template>
  <div>
    <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
  </div>
</template>
<script>
import Toast from '@/components/Toast'
import { querystatus, gobuy } from '@/services/commodity'
import tujiaRedirect from '@/utils/tujiaRedirect.js'
import tujialogin from '@/utils/tujialogin.js'
import { geocoder } from '@/services/city'
import { searchfilteritem } from '@/services/filter'
import urlHelper from '@lib/utils/urlHelper'
import { mpUtils } from '@tujia/fe-lib-bridge'

export default {
  mixins: [tujiaRedirect, tujialogin],
  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: ''
    }
  },
  watch: {
    payLoad(newVal) {
      if (!newVal) {
        return
      }
      if (newVal.status === 1) {
        // 立即使用
        // this.doShowToast('您已购买过该商品')
        this.redirectToHouseListPage(newVal)
      } else if (newVal.status === 2) {
        // 已售罄
        this.doShowToast('好可惜，该商品已经售完了')
      } else if (newVal.status === 0) {
        // 未购买
        this.bugCommodity()
      }
    }
  },
  mounted() {
    this.initRedPacket()
  },
  methods: {
    /**
     * 红包初始化
     */
    async initRedPacket() {
      const ids = []
      let redpackets = this.compProps.mate.items
      redpackets.forEach((redpacket) => {
        ids.push(parseInt(redpacket.id, 10))
      })
      const res = await querystatus(ids)
      if (res && res.errcode === 0) {
        redpackets.forEach((item, index) => {
          item.offerPrice = res.data.items[index] && res.data.items[index].offerPrice
          item.bought = res.data.items[index] && res.data.items[index].bought
          item.unableSell = !(res.data.items[index] && res.data.items[index].unableSell)
        })
        this.$emit('init', redpackets || [])
      } else {
        this.$emit('init', [])
      }
    },
    /**
     * 显示toast
     * @param {String} msg toast内容
     */
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    },
    /**
     * bridge 支付
     * @param {String} token token
     * @returns {订单编号} tradeNo 订单编号
     */
    goToBridge({ token, tradeNo }) {
      window.tjBridge.business.doPayment({
        payTradeNo: tradeNo,
        token: token,
        success: (res) => {
          try {
            window.location.reload()
          } catch (error) {
            console.log(error)
          }
        },
        fail: () => {
        },
        final: () => {
        }
      })
    },
    /**
     * 购买商品
     */
    async bugCommodity() {
      let resultUrl = window.location.href
      if (this.platformEnv.isMpEnv || this.platformEnv.isTouTiaoMpEnv) {
        resultUrl = `/pages/webview/index?h5url=${encodeURIComponent(resultUrl)}`
      }
      const res = await gobuy({
        productId: this.compProps.mate.items[this.payLoad.commodityIndex].id,
        productName: this.compProps.mate.items[this.payLoad.commodityIndex].itemName,
        successUrl: resultUrl,
        failureUrl: resultUrl,
        cancelUrl: resultUrl,
        offerPrice: this.compProps.mate.items[this.payLoad.commodityIndex].offerPrice
      })
      if (res && res.errcode === 0) {
        if (this.platformEnv.isMpEnv || this.platformEnv.isTouTiaoMpEnv) {
          // business 1:房单，2:押金宝，3:其他
          let url = '/pages/pay_v2/index/index?payTradeNo=' + res.data.tradeNo + '&token=' + res.data.token + '&businessType=3'
          mpUtils.navigateTo({
            url
          })
        } else {
          if (this.platformEnv.isTujiaAppEnv) {
            this.goToBridge(res.data)
          } else {
            let href = process.env.VUE_APP_PAY_TUJIA_HOST + 'pwa/checkstand?payTradeNo=' + res.data.tradeNo + '&token=' + res.data.token
            window.location.href = href
          }
        }
      } else if (res.errcode === 55004) {
        this.goLoginPage()
      } else if (res.data && res.data.unableSell) {
        this.initRedPacket()
        this.doShowToast(res.errmsg || '好可惜，该商品已经售完了')
      } else {
        this.doShowToast(res.errmsg)
      }
    },
    async redirectToHouseListPage(redpack) {
      let CITYREG = new RegExp(/CITYID/, 'g')
      let geoInfo = await geocoder({ parameter: {} })
      let urlobj = urlHelper.getQueryStringByStringUrl(redpack.activeLink)
      let isSupportFilter = await searchfilteritem({ cityId: (geoInfo && geoInfo.data && geoInfo.data.cityId) || 48, filterValue: urlobj.cds || '' })
      let cityId = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityId : 48
      let cityName = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityName : '北京'
      let isOverSea = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.oversea ? 2 : 1 : 1
      let _maplink = redpack.mpLink && redpack.mpLink.replace(CITYREG, cityId).replace('城市名称', cityName).replace('城市类型', isOverSea)
      let redirectUrl = {
        mpLink: _maplink,
        appLink: redpack.appLink && redpack.appLink.replace(CITYREG, cityId),
        activeLink: redpack.activeLink && redpack.activeLink.replace(CITYREG, cityId),
        isJumpApp: this.compProps.mate.privateProps.isJumpApp
      }
      this.doRedirect(redirectUrl, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.mask-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}
</style>
